import {
  ConsultantsQueryTeacherFormInput,
  QualificationFilter,
  SelectType
} from "@graphql";

export const teacherInitialValues: ConsultantsQueryTeacherFormInput = {
  areaOfExpertise: [],
  areaSelectType: SelectType.ANY,
  qualified: QualificationFilter.Any
};
